import {
  axiosPut,
  del,
  get,
  getPollsAxiosWithParams,
  post,
} from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  createPlaceFailed,
  createPlaceSuccess,
  deletePlaceFailed,
  deletePlaceSuccess,
  getChaptersFailed,
  getChaptersSuccess,
  getCompletedSurveysFailed,
  getCompletedSurveysSuccess,
  getPlaceDataFailed,
  getPlaceDataSuccess,
  getPlacesFailed,
  getPlacesReportsFailed,
  getPlacesReportsSuccess,
  getPlacesSuccess,
  getPlacesSummaryReportsFailed,
  getPlacesSummaryReportsSuccess,
  getPlaceSurveyRepliesFailed,
  getPlaceSurveyRepliesSuccess,
  getPlacesWithChaptersFailed,
  getPlacesWithChaptersSuccess,
  hideBulkUploadModal,
  hideConfirmDeleteModal,
  setBulkUploadFlag,
  updatePlaceFailed,
  updatePlaceSuccess,
  uploadBulkPlacesFailed,
  uploadBulkPlacesSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import {
  CREATE_PLACE,
  DELETE_PLACE,
  GET_CHAPTERS,
  GET_COMPLETED_SURVEYS,
  GET_PLACES,
  GET_PLACES_REPORTS,
  GET_PLACES_SUMMARY_REPORTS,
  GET_PLACES_WITH_CHAPTERS,
  GET_PLACE_DATA,
  GET_PLACE_SURVEY_REPLIES,
  UPDATE_PLACE,
  UPLOAD_BULK_PLACES,
} from "./actionTypes"
import { URL_PATHS } from "constants/index"

function* getPlaces({ payload: params }) {
  try {
    const response = yield get(url.PLACES_URL, { params })
    yield put(getPlacesSuccess(response))
  } catch (error) {
    yield put(getPlacesFailed(error))
    showToast("error", error, "Error")
  }
}

function* getPlaceData({ payload: params }) {
  try {
    const response = yield get(`${url.PLACES_URL}/${params?.id}`)
    yield put(getPlaceDataSuccess(response))
  } catch (error) {
    yield put(getPlaceDataFailed(error))
    showToast("error", error, "Error")
  }
}

function* createPlace({ payload: params }) {
  try {
    const response = yield post(url.ADMIN_PLACE_URL, params?.values)
    yield put(createPlaceSuccess(response))
    params?.history.push(URL_PATHS.PLACES)
    showToast("success", "Place created!", "Success")
  } catch (error) {
    yield put(createPlaceFailed(error))
    showToast("error", error, "Error")
  }
}

function* updatePlace({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.ADMIN_PLACE_URL}/${params?.values?.id}`,
      params?.values
    )
    yield put(updatePlaceSuccess(response))
    params?.history.push(URL_PATHS.PLACES)
    showToast("success", "Place created!", "Success")
  } catch (error) {
    yield put(updatePlaceFailed(error))
    showToast("error", error, "Error")
  }
}

function* deletePlace({ payload: params }) {
  try {
    const response = yield del(`${url.ADMIN_PLACE_URL}/${params?.id}`)
    yield put(deletePlaceSuccess(response))
    yield put(hideConfirmDeleteModal())
    showToast("success", "Place deleted!", "Success")
    if (params?.callback) {
      params?.callback()
    }
  } catch (error) {
    yield put(deletePlaceFailed(error))
    showToast("error", error, "Error")
  }
}

function* getCompletedSurveys({ payload: params }) {
  try {
    const response = yield getPollsAxiosWithParams(
      `/completed-surveys-for-place/${params?.id}`
    )
    yield put(getCompletedSurveysSuccess(response))
  } catch (error) {
    yield put(getCompletedSurveysFailed(error))
    showToast("error", error, "Error")
  }
}

function* getPlaceSurveyReplies({ payload: params }) {
  try {
    const response = yield get("/admin/place-survey-replies", { params })
    yield put(getPlaceSurveyRepliesSuccess(response))
  } catch (error) {
    yield put(getPlaceSurveyRepliesFailed(error))
    showToast("error", error, "Error")
  }
}

function* uploadBulkPlaces({ payload: params }) {
  try {
    const response = yield post("/admin/multiple-places", params)
    yield put(uploadBulkPlacesSuccess(response))
    yield put(setBulkUploadFlag(false))
    yield put(hideBulkUploadModal())
    showToast("success", "Places successfully imported", "Success")
  } catch (error) {
    yield put(uploadBulkPlacesFailed(error))
    yield put(setBulkUploadFlag(false))
    showToast("error", error, "Error")
  }
}

function* getPlacesWithChapters({ payload: params }) {
  try {
    const response = yield get(url.PLACES_URL, { params })
    yield put(getPlacesWithChaptersSuccess(response))
  } catch (error) {
    yield put(getPlacesWithChaptersFailed(error))
    showToast("error", error, "Error")
  }
}

function* getChapters({ payload: params }) {
  try {
    const response = yield get(url.CHAPTERS_URL, { params })
    yield put(getChaptersSuccess(response))
  } catch (error) {
    yield put(getChaptersFailed(error))
    showToast("error", error, "Error")
  }
}

function* getPlacesReports({ payload: params }) {
  try {
    const response = yield get(url.PLACES_REPORTS_URL, { params })
    yield put(getPlacesReportsSuccess(response))
  } catch (error) {
    yield put(getPlacesReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getPlacesSummaryReports({ payload: params }) {
  try {
    const response = yield get(url.PLACES_SUMMARY_REPORTS_URL, { params })
    yield put(getPlacesSummaryReportsSuccess(response))
  } catch (error) {
    yield put(getPlacesSummaryReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* placesListSaga() {
  yield takeEvery(GET_PLACES, getPlaces)
  yield takeEvery(GET_PLACE_DATA, getPlaceData)
  yield takeEvery(CREATE_PLACE, createPlace)
  yield takeEvery(UPDATE_PLACE, updatePlace)
  yield takeEvery(DELETE_PLACE, deletePlace)
  yield takeEvery(GET_COMPLETED_SURVEYS, getCompletedSurveys)
  yield takeEvery(GET_PLACE_SURVEY_REPLIES, getPlaceSurveyReplies)
  yield takeEvery(UPLOAD_BULK_PLACES, uploadBulkPlaces)
  yield takeEvery(GET_PLACES_WITH_CHAPTERS, getPlacesWithChapters)
  yield takeEvery(GET_CHAPTERS, getChapters)
  yield takeEvery(GET_PLACES_REPORTS, getPlacesReports)
  yield takeEvery(GET_PLACES_SUMMARY_REPORTS, getPlacesSummaryReports)
}

export default placesListSaga
